import { Outlet } from 'react-router-dom'

const Order = () => {
    return (
        <div>
            <Outlet />
        </div>
    )
}

export default Order;